import React from "react";
import { Outlet } from "react-router-dom";
const PropertyTypeRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PropertyTypeRoot;
